import { omit } from '@fabric-app/utils/object/manipulation';
import { useMutation } from '@tanstack/react-query';

const useMutationWithOptimisticContext = (options) => {
  const mutationOptions = omit(options, [
    "getOptimisticContext"
  ]);
  const mutation = useMutation(mutationOptions);
  return {
    ...mutation,
    mutateAsync: async (data) => {
      const optimisticContext = options.getOptimisticContext?.(data);
      return mutation.mutateAsync({
        ...data,
        context: optimisticContext
      });
    },
    mutate: (data, mutateOptions) => {
      const optimisticContext = options.getOptimisticContext?.(data);
      mutation.mutate({
        ...data,
        context: optimisticContext
      }, mutateOptions);
    }
  };
};

export { useMutationWithOptimisticContext };
//# sourceMappingURL=useMutationWithOptimisticContext.js.map
